export default __webpack_public_path__ + "static/media/net-worth.ea69d414.png";